import {
  Paper,
  TextInput,
  PasswordInput,
  Button,
  Title,
  Text,
  Anchor,
} from "@mantine/core";
import { useForm, yupResolver } from "@mantine/form";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { UserLoginDto } from "../../../models/user.model";
import { signIn, signInReset } from "../../../redux/reducers/authSlice";
import { selectIsAuthenticated, selectSignInLoading, selectSignInSuccess } from "../../../redux/selectors/authSelector";
import { useEffect } from "react";
import { RouteName } from "../../../utils/routing/routes.helper";
import DialogStatus from "../../common/dialog-status/dialog-status";
import classes from "./login-page.module.css";
import * as yup from "yup";

export function LoginPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const signInSuccessSelector = useSelector(selectSignInSuccess);
  const signInLoadingSelector = useSelector(selectSignInLoading);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const schema = yup.object({
    email: yup
      .string()
      .email("Invalid email address")
      .required("Email is required"),
    password: yup.string().required("Password is required"),
  });

  const form = useForm({
    initialValues: {
      email: "",
      password: "",
    },
    validate: yupResolver(schema),
  });

  const handleSubmit = (values: UserLoginDto) => {
    dispatch(signIn({email: values.email?.trim(), password: values.password?.trim()}));
  };

  useEffect(() => {
    if (signInSuccessSelector || isAuthenticated) {
      navigate(RouteName.DASHBOARD);
      dispatch(signInReset());
    }
  }, [signInSuccessSelector, isAuthenticated, navigate]);

  return (
    <div className={classes.wrapper}>
      <Paper className={classes.form} radius={0} p={30}>
        <Title order={2} className={classes.title} ta="center" mt="md" mb={50}>
          Welcome to The Greek Wedding Show!
        </Title>
        <form onSubmit={form.onSubmit(handleSubmit)}>
          <TextInput
            label="Email"
            placeholder="admin@gmail.com"
            size="md"
            {...form.getInputProps("email")}
          />
          <PasswordInput
            label="Password"
            placeholder="Your password"
            mt="md"
            size="md"
            {...form.getInputProps("password")}
          />
          <Button fullWidth mt="xl" size="md" loading={signInLoadingSelector} type="submit">
            Login
          </Button>
        </form>

        <Text ta="center" mt="md">
          Don&apos;t have an account?{" "}
          <Anchor<"a"> href="#" fw={700} onClick={() => navigate("/signup")}>
            Register
          </Anchor>
        </Text>
      </Paper>
      <DialogStatus />
    </div>
  );
}
